import { useAuth0 } from '@auth0/auth0-react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
    Alert,
    Box,
    Button,
    Card,
    Chip,
    CircularProgress,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import axios from 'axios';
//import { saveAs } from 'file-saver';
import React, { useEffect, useState } from 'react';
import { pdfjs } from 'react-pdf';
import { useSelector } from 'react-redux';
import DocumentPreview from './DocumentPreview';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const MAX_LENGTH = 180;

const Documents = props => {
    //Props gs1pk, schoolId, loadOnInit
    const { getAccessTokenSilently } = useAuth0();
    const [documents, setDocuments] = useState({
        documents: [],
        loaded: false,
        error: '',
        requested: false,
    });

    const [download, setDownload] = useState(false);
    const [viewDocument, setViewDocument] = useState({ type: '' });
    const profile = useSelector(state => state.profile);

    async function getDocuments() {
        setDocuments({
            documents: [],
            loaded: false,
            error: '',
            requested: true,
        });
        const token = await getAccessTokenSilently({
            scope: process.env.REACT_APP_scope,
        });
        const documentRes = await axios
            .post(
                `/getReadDocuments`,
                { id: props.gs1pk },
                {
                    baseURL: process.env.REACT_APP_API_GATEWAY,
                    url: `/getReadDocuments`,
                    timeout: 30000,
                    headers: {
                        authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            )
            .catch(err => {
                setDocuments({
                    documents: [],
                    loaded: true,
                    error: 'Failed to get users documents',
                    requested: true,
                });
            });
        console.log('documents', documentRes.data.Message.Data);
        if (documentRes.status === 200) {
            console.log(
                'documentRes.data.Message.Data',
                documentRes.data.Message.Data
            );
            const filteredDocuments = documentRes.data.Message.Data.filter(
                doc => {
                    if (
                        props.filterResume === true &&
                        doc.sk1.substring(0, 7) === 'Resume#' &&
                        doc.sk1 === props.jobSk1
                    ) {
                        return true;
                    } else if (
                        props.filterResume === true &&
                        doc.sk1.substring(0, 7) !== 'Resume#'
                    ) {
                        return true;
                    } else if (props.filterResume === false) {
                        return true;
                    } else {
                        return false;
                    }
                }
            );
            setDocuments({
                documents: filteredDocuments,
                loaded: true,
                error: '',
                requested: true,
            });
        } else {
            setDocuments({
                documents: [],
                loaded: true,
                error: 'Failed to get users documents',
                requested: true,
            });
        }
    }

    useEffect(() => {
        if (props.loadOnInit) {
            getDocuments();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const showItem = async (filename, date, type) => {
        setDownload(true);
        const token = await getAccessTokenSilently({
            scope: process.env.REACT_APP_scope,
        });
        let url = '/getSignedDocument';

        await axios
            .get(url, {
                baseURL: process.env.REACT_APP_API_GATEWAY,
                url: url,
                timeout: 30000,
                headers: {
                    authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                params: {
                    id: props.gs1pk,
                    Filename: filename,
                    Date: date,
                    userType: 'school',
                },
            })
            .then(output => {
                console.log('returned', output);
                setDownload(false);
                setViewDocument({
                    ...viewDocument,
                    'type': type,
                    url: output.data.Message.Data.downloadURL,
                });
            })
            .catch(() => {
                setDownload(false);
                setViewDocument({
                    ...viewDocument,
                    'type': '',
                });
            });
    };

    return (
        <div>
            {profile.profile.Data.Items[0].role === 'admin' ? (
                <Box
                    sx={{
                        marginBottom: '24px',
                        width: '100%',
                        backgroundColor: '#FFFFFF',
                        borderRadius: '4px',
                        boxShadow:
                            props.border === false
                                ? ''
                                : '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
                    }}
                >
                    <Grid
                        container
                        xs={12}
                        directon="column-reverse"
                        alignItems="stretch"
                    >
                        <Grid item xs={12}>
                            <Typography variant="h6" sx={{ padding: '12px' }}>
                                Relief Teacher Profile Documents
                            </Typography>
                        </Grid>
                        {documents.requested ? (
                            <Grid item xs={12}>
                                {documents.loaded ? (
                                    <Box>
                                        {documents.error === '' ? (
                                            <Box>
                                                <TableContainer>
                                                    <Table aria-label="simple table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell
                                                                    style={{
                                                                        width: 30,
                                                                    }}
                                                                ></TableCell>
                                                                <TableCell align="left">
                                                                    Type
                                                                </TableCell>
                                                                <TableCell align="left">
                                                                    Description
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        {documents.documents
                                                            .length > 0 ? (
                                                            <TableBody>
                                                                {documents.documents.map(
                                                                    row => (
                                                                        <TableRow
                                                                            data-cy="doc-row"
                                                                            key={
                                                                                row.url
                                                                            }
                                                                            sx={{
                                                                                '&:last-child td, &:last-child th':
                                                                                    {
                                                                                        border: 0,
                                                                                    },
                                                                            }}
                                                                        >
                                                                            <TableCell
                                                                                component="th"
                                                                                scope="row"
                                                                                style={{
                                                                                    width: 30,
                                                                                }}
                                                                            >
                                                                                {/* <DownloadIcon
                                                                            onClick={() =>
                                                                                downloadDocument(
                                                                                    props.gs1pk,
                                                                                    row.url,
                                                                                    row.date,
                                                                                    props.schoolId
                                                                                )
                                                                            }
                                                                        /> */}
                                                                                <Chip
                                                                                    label="View"
                                                                                    data-cy="view-doc"
                                                                                    icon={
                                                                                        <VisibilityIcon />
                                                                                    }
                                                                                    onClick={() => {
                                                                                        showItem(
                                                                                            row.url,
                                                                                            row.date,
                                                                                            row.filetype
                                                                                        );
                                                                                    }}
                                                                                />
                                                                            </TableCell>
                                                                            <TableCell align="left">
                                                                                {
                                                                                    row.sk1
                                                                                }
                                                                            </TableCell>
                                                                            {row.description !==
                                                                            null ? (
                                                                                <>
                                                                                    {row
                                                                                        .description
                                                                                        .length >
                                                                                    MAX_LENGTH ? (
                                                                                        <TableCell align="left">
                                                                                            {`${row.description.substring(
                                                                                                0,
                                                                                                MAX_LENGTH
                                                                                            )}...`}
                                                                                            {/* <a href="#">
                                                                            Read
                                                                            more
                                                                        </a> */}
                                                                                        </TableCell>
                                                                                    ) : (
                                                                                        <TableCell
                                                                                            align="left"
                                                                                            data-cy="doc-desc"
                                                                                        >
                                                                                            {
                                                                                                row.description
                                                                                            }
                                                                                        </TableCell>
                                                                                    )}
                                                                                </>
                                                                            ) : (
                                                                                <TableCell align="left">
                                                                                    No
                                                                                    Description
                                                                                </TableCell>
                                                                            )}
                                                                            {/* <TableCell align="left">
                                                                    {
                                                                        row.description
                                                                    }
                                                                </TableCell> */}
                                                                        </TableRow>
                                                                    )
                                                                )}
                                                            </TableBody>
                                                        ) : (
                                                            <TableBody>
                                                                <TableRow>
                                                                    <TableCell></TableCell>
                                                                    <TableCell>
                                                                        <Typography>
                                                                            No
                                                                            Documents
                                                                            Available
                                                                        </Typography>
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        )}
                                                    </Table>
                                                </TableContainer>

                                                {download === true ? (
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent:
                                                                'center',
                                                        }}
                                                    >
                                                        <CircularProgress
                                                            sx={{
                                                                margin: '40px',
                                                            }}
                                                        />
                                                    </Box>
                                                ) : (
                                                    <DocumentPreview
                                                        viewDocument={
                                                            viewDocument
                                                        }
                                                    />
                                                )}
                                            </Box>
                                        ) : (
                                            <Alert
                                                severity="error"
                                                action={
                                                    <Button
                                                        color="inherit"
                                                        size="small"
                                                        onClick={getDocuments}
                                                    >
                                                        Retry
                                                    </Button>
                                                }
                                            >
                                                {documents.error}
                                            </Alert>
                                        )}
                                    </Box>
                                ) : (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <CircularProgress
                                            sx={{ margin: '20px' }}
                                        />
                                    </Box>
                                )}
                            </Grid>
                        ) : (
                            <Grid item xs={12}>
                                <Button
                                    sx={{ margin: '20px' }}
                                    variant="contained"
                                    onClick={getDocuments}
                                    data-cy="view-docs"
                                >
                                    View the Relief Teachers Profile Documents
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                </Box>
            ) : (
                <div></div>
            )}
        </div>
    );
};

export default Documents;
